import { Component } from '@angular/core';
import { ActiveFacetsComponent } from '@spartacus/storefront';

@Component({
  selector: 'cx-active-facets',
  templateUrl: './active-facets.component.html',
  styleUrl: './active-facets.component.scss',
  standalone: false,
})
export class CustomActiveFacetsComponent extends ActiveFacetsComponent {}
